import store from '@/store/store'
import { io } from 'socket.io-client'
import { updateStoreData } from '@/utils/update_store_data'

export async function mixinSocketConnection() {
  const token = store.getters['auth/token']
  const connect = (io, token) => {
    return io.connect(process.env.VUE_APP_SOCKET_URL, {
      transports: ['websocket'],
      query: `token=${token}`
    })
  }
  const socket = await connect(io, token)
  socket.on('connect', () => {
    store.dispatch('petorelu/setSocket', socket)
    store.dispatch('auth/addSocketConnectCounts')
  })
  socket.on('logout', () => {
    store.dispatch('auth/showLogoutPopup')
  })
  socket.on(
    'updateTables',
    async ({ allFlg, errFlg, socketId, tables, updatedAt }) => {
      if (
        allFlg ||
        errFlg ||
        socketId !== store.getters['petorelu/get'].socket.id
      ) {
        await updateStoreData(tables, updatedAt)
      }
    }
  )
  socket.on(
    'setLockingClientKeys',
    ({ patient, medicalRecord, hospitalization }) => {
      store.dispatch('auth/setLockingClientKeys', {
        patient,
        medicalRecord,
        hospitalization
      })
    }
  )
  socket.on(
    'setFlashLockParams',
    ({ patientId, medicalRecordOriginalId, hospitalizationId }) => {
      store.dispatch('auth/setFlashLockParams', {
        patientId,
        medicalRecordOriginalId,
        hospitalizationId
      })
    }
  )
}

export default {
  methods: {
    mixinSocketConnection
  }
}
